{
  "name": "@unkey/hono",
  "version": "1.5.0",
  "main": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "license": "MIT",
  "private": false,
  "publishConfig": {
    "access": "public"
  },
  "keywords": [
    "unkey",
    "client",
    "api",
    "hono"
  ],
  "bugs": {
    "url": "https://github.com/unkeyed/unkey/issues"
  },
  "homepage": "https://github.com/unkeyed/unkey#readme",
  "files": [
    "./dist/**"
  ],
  "author": "Andreas Thomas <andreas@chronark.com>",
  "scripts": {
    "build": "tsup",
    "test": "vitest run"
  },
  "devDependencies": {
    "@types/node": "^20.14.9",
    "hono": "^4.6.3",
    "msw": "^2.8.7",
    "tsup": "^8.0.2",
    "typescript": "^5.5.3",
    "zod": "^3.23.5"
  },
  "dependencies": {
    "@unkey/api": "workspace:^"
  },
  "peerDependencies": {
    "hono": "^4.6.3"
  }
}
